<template>
  <section class="container more-info">
    <div class="row">
        <div class="col-1 hidden-sm"></div>
        <div class="col-6 lft">
          <!-- mobile only about section -->
          <div class="section mob desc" v-show="($props.isMobile && $props.park.description !== null && $props.park.description !== '') ">
            <h2 @click="toggleCollapse($event)" class="arrow-up">About {{ $props.park.name }}</h2>
            <div class="open">
                <p v-html="$props.park.description"></p>
            </div>
          </div>

          <div class="section about" v-show="($props.park.about_park !== null && $props.park.about_park !== '')">
            <h2 @click="toggleCollapse($event)">More about {{ $props.park.name }}</h2>
            <div class="open" :class="{'collapsed': $props.isMobile}">
                <p v-html="$props.park.about_park"></p>
            </div>
          </div>

           <div class="section getting-there" v-show="$props.park.getting_to !== null && $props.park.getting_to !== ''">
            <h2 @click="toggleCollapse($event)">Getting to {{ $props.park.name }}</h2>
              <div class="open" :class="{'collapsed': $props.isMobile}">
                <p v-html="$props.park.getting_to"></p>
            </div>
          </div>

          <div class="section facilities" v-show="$props.park.facilities_description !== null && $props.park.facilities_description !== ''">
            <h2 @click="toggleCollapse($event)">Facilities at {{ $props.park.name }}</h2>
              <div class="open" :class="{'collapsed': $props.isMobile}">
                <p>{{ $props.park.facilities_description }}</p>
              </div>
          </div>

          <div class="section about" v-show="$props.park.about_location !== null && $props.park.about_location !== ''">
            <h2 @click="toggleCollapse($event)">About {{ $props.park.region }}</h2>
            <div class="open" :class="{'collapsed': $props.isMobile}">
                <p>{{ $props.park.about_location }}</p>
            </div>
          </div>

          <div class="section map" v-if="$props.activeTab !== 'mobile'">
            <h2>Maps</h2>
            <Map
                :map="$props.map"
            />
          </div>

        </div>

        <div class="col-4 rgt">

           <div v-show="$props.park.facilities" class="section at-park" v-if="attractions[0] || starAttractions[0]">
            <h2 @click="toggleCollapse($event)">At this park</h2>
             <div class="open" :class="{'collapsed': $props.isMobile}">
                <ul class="attraction star" v-if="starAttractions[0]">
                  <Attraction
                    :star="true"
                    v-for="(attraction, index) in starAttractions"
                    :key="attraction.index"
                    :attraction="attraction"
                  />
                </ul>
                <ul class="section attraction" v-if="attractions[0]">
                  <Attraction
                    :star="false"
                    v-for="(attraction, index) in attractions"
                    :key="attraction.index"
                    :attraction="attraction"
                  />
                </ul>
              </div>
           </div>

           <div class="section note" v-if="$props.park.notes">
            <h2>Notes</h2>
            <div v-for="note in $props.park.notes">
                <p>{{ note }}<p/>
            </div>
           </div>
        </div>
    </div>
  </section>
</template>

<script>
import Map from '../shared/map.vue'
import Attraction from '../comp_lodges/attraction.vue'

export default {
    data: function () {
        return {
          starAttractions: [],
          attractions: []
        }
  },
  props: {
     park: Object,
     map: {
         type: Object,
         required: true
     },
     activeTab: String,
     isMobile: Boolean
  },
  components: {
    Map, Attraction
  },
  methods: {
    toggleCollapse: function(e) {
      //IE 11 fix- closest not supported
      if (window.innerWidth < 1024) {
        let para = e.target.parentNode.querySelector('.open');
        e.target.classList.toggle('arrow-up');
        para.classList.toggle('collapsed');
      }
        
    },

    formatFacilities: function() {
      if (!this.park.facilities) {
        return; 
      }
      
      var starArr = [],
          arr=[];
      this.park.facilities.forEach(item => {
        if (item['highlighted'] === true) {
          starArr.push(item['name'])
        } else{
          arr.push(item['name'])
        }
      });
      this.starAttractions = starArr;
      this.attractions = arr;
    }
  },
  mounted: function () {
    this.formatFacilities();
  }
}
</script>

<style scoped lang="scss">
@import 'app/assets/stylesheets/_vars.scss';

br {
  display: none;
}

.more-info {
  display: block;
  padding: 1.25rem;
  box-sizing: border-box;

  p:empty {
    display: none;
  }
}

p {
  font-size: .875rem;
  line-height: 1.4;
  padding: 1rem 0 2rem;
  white-space: pre-wrap;
}

h2 {
  font-weight: 400;
  padding: .688rem 2rem .5rem 0;
  font-size: 1rem;
  position: relative;
  text-align: left;
  border-bottom: .063rem solid $col_bgrey;
  cursor: pointer;

  &.arrow-up {

    &:after {
      border-bottom: .375rem solid #000;
      border-top: none;
    }
  }

  &:after {
    content: '';
    position: absolute;
    top: 50%;
    right: 0.5rem;
    -webkit-transform: translateY(-50%);
    transform: translateY(-50%);
    border-left: .375rem solid transparent;
    border-right: .375rem solid transparent;
    border-top: .375rem solid #000;
  }
}

.lft,
.rgt {
    box-sizing: border-box;
}

.map,
.note {
   display: none;
}

.at-park ul {
    padding: 0 0 1.25rem 0;
    position: relative;
    display: flex;
    list-style: none;
    width: 100%;
    flex-wrap: wrap;
    
    &.star {
      border-bottom: .063rem solid $col_bgrey;
    }
}

.note {
  h3 {
    font-weight: bold;
    padding: 2rem 0 0 0;
  }
}

.open {
  max-height: 100rem;
  transition: all 0.3s ease-in-out;
  overflow: hidden;

  &.collapsed {
    max-height: 0;
    padding-bottom: 1rem;
  }
}

@media #{$desktop} {

    .mob {
      display: none;
    }

    h2 {
      padding: 0 0 1.25rem 0;
      font-size: 1.25rem;
      border-bottom: .125rem solid $col_bgrey;
      cursor: initial;

      &:after{
        display: none;
      }
    }

    .at-park {
      margin-bottom: 2rem;
    }

    p {
      padding: 1.25rem 0;
    }

    .more-info {
      display: flex;
      padding: 0;
    }

    .map,
    .note {
      display: block;
    }
}
</style>